import React, { useState }  from 'react'
import axios from 'axios'
const APIURL = process.env.NODE_ENV === 'production' ? `${process.env.REACT_APP_DB_ENV}` : `${process.env.REACT_APP_DB_ENV_TEST}`
const sample = [{speaker:'You','msg':'What is Apple Inc.?'},{speaker:'AI','msg':'Apple is an American multinational technology company.'}]
export default function LlmGoogleSearch() {
    const [loadingMsg, setLoadingMsg]= useState(false)
    const [script, setScript]= useState(sample)
    const [userInput, setUserInput] = useState({question:'What is Apple Inc.?'})
    const onChange2Input = ({ currentTarget: x }) => {setUserInput({ ...userInput, [x.name]: x.value })}
    const onClick2GoogleSearch=async()=>{
      script.push({speaker:'You',msg:userInput.question})
      setLoadingMsg(true)
      try {
        const { data: res } = await axios.post(`${APIURL}/llm-googlesearch`,userInput)
        console.log(res)
        script.push({speaker:'AI','msg':res['answer']})
        setLoadingMsg(false)
      } catch (err) {
        console.log(err)
      }
    }
    return (
    <>
      <div className='mt-[2px] flex'>
      <input className='pl-[2px] border border-gray-800 w-full md:w-80 mr-[2px]'  name='question' type='text' defaultValue='What is Apple Inc.?' onChange={onChange2Input}/>
      <button className='bg-gray-800 hover:bg-gray-700 h-auto pl-[8px] pr-[8px] text-white text-[12px]' onClick={onClick2GoogleSearch}>Ask to AI</button>
      </div>
      <div className='text-left'>
      <>{script.map((x)=><>{x.speaker}: {x.msg}<br/></>)}</>
      {loadingMsg?<p className='flex text-xs'>Please wait for a moment<span className='primary-loader1'>.</span><span className='primary-loader2'>.</span><span className='primary-loader3'>.</span></p>:''}
      </div>
    </>
    )
}